<template>
  <div
    :class="{
      'row resource-card-container py-30px pl-70px pr-52px md:max-w-1/2 md:px-5 lg:max-w-none xl:px-11': true,
      'text-www-color-neutral-medium-dark': true,
      'xl:px-5': menuType === 'solutions',
      'xl:px-11': menuType === 'resources' || menuType === 'product',
    }"
  >
    <div
      :class="{
        'mb-4 flex justify-between': true,
        'text-www-color-white md:text-www-color-neutral-medium-dark': true,
      }"
    >
      <h3
        :class="{
          'feature-card-title text-xs font-bold uppercase tracking-[0.0375rem] md:text-www-color-accent-teal-dark': true,
        }"
      >
        {{ heading }}
      </h3>

      <PTCLink
        v-if="viewAllButton?.link?.currentPathname"
        :to="viewAllButton?.link?.currentPathname"
        :class="{
          'feature-card-view-all flex items-center gap-5px text-10px font-bold uppercase leading-3 tracking-wide text-www-color-white transition-colors hover:text-www-color-neutral-medium-light md:text-www-color-neutral-light': true,
        }"
      >
        <img
          v-if="viewAllImageSrc"
          :src="viewAllImageSrc"
          alt="View All"
          loading="lazy"
          width="13"
        />
        {{ viewAllButton?.text || 'View All' }}
      </PTCLink>
    </div>
    <div
      :class="{
        'resource-card grid grid-cols-12 border border-www-color-neutral-very-light': true,
      }"
    >
      <div
        :class="{
          'col-span-12 h-100px overflow-hidden md:col-span-4 md:h-auto': true,
        }"
      >
        <img
          v-if="card._type == 'video' && card?.cardImageSrc"
          :class="{ 'min-h-full w-full object-cover': true }"
          :src="card.cardImageSrc"
          alt="Card hero image"
          loading="lazy"
        />
        <PtcPicture
          v-else-if="card.cardImageRef?.asset"
          provider="sanity"
          :img-attrs="{ class: 'min-h-full w-full object-cover' }"
          :modifiers="{ w: 400 }"
          :alt="resolvedImage?.altText || 'Card hero image'"
          :src="card.cardImageRef.asset._ref"
        />
      </div>
      <div
        :class="{
          'card-details col-span-12 bg-www-color-white px-6 py-14px md:col-span-8': true,
        }"
      >
        <div
          :class="{
            'resource-card-type pb-6px text-10px uppercase leading-3 text-www-color-neutral-light': true,
          }"
        >
          {{
            card._type == 'whatIsNew' || card._type == 'caseStudy' ?
              formatDateUTC(card.articleDate, 'MM.DD.YYYY')
            : contentTypeToLabel(card._type)
          }}
        </div>
        <div
          :class="{
            'resource-card-title mb-10px text-sm font-bold leading-4 tracking-wider': true,
          }"
        >
          {{ card.title }}
        </div>
        <a
          v-if="card.currentPathname"
          :class="{
            'resource-link text-10px font-bold uppercase leading-3 text-www-color-primary-lighter': true,
          }"
          :href="card.currentPathname"
          >{{ card.cardButtonText }}</a
        >
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PTCLink from '~/components/Atmos/PTCLink/PTCLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { CardBlogResult, InternalLinkRefQueryResult } from '~/sanity/types';
import { contentTypeToLabel } from '~/utils/contentTypeToLabel';
type PropType = {
  card: NonNullable<CardBlogResult>;
  heading?: string;
  menuType?: 'solutions' | 'resources' | 'product';
};
const props = defineProps<PropType>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.card.cardImageRef?.asset?._ref);
const viewAllButton = inject('viewAllLink') as {
  text: string;
  link: InternalLinkRefQueryResult | null;
} | null;

const { $staticImages } = useNuxtApp();
const viewAllImageSrc = $staticImages['view-all'];
</script>
<style scoped></style>
